import React from 'react';

export default function ConfigPanel({ config, setConfig, disabled }) {
  const handleBatchChange = (e) => {
    // Clamp between 1 and 500
    const val = Math.min(500, Math.max(1, Number(e.target.value) || 1));
    setConfig((prev) => ({ ...prev, batchSize: val }));
  };

  const handleDecrease = () => {
    if (disabled) return;
    setConfig((prev) => ({ ...prev, batchSize: Math.max(1, (prev.batchSize || 10) - 10) }));
  };

  const handleIncrease = () => {
    if (disabled) return;
    setConfig((prev) => ({ ...prev, batchSize: Math.min(500, (prev.batchSize || 10) + 10) }));
  };

  return (
    <div className={`bg-white border border-orange-100 rounded-2xl p-5 shadow-sm flex flex-col gap-4 ${disabled ? 'opacity-60 pointer-events-none' : ''}`}>
      <h3 className="text-slate-700 font-bold flex items-center gap-2 text-sm">
        <span className="text-base">⚙️</span> Configuration
      </h3>

      <div>
        <label className="text-slate-400 text-xs font-semibold mb-2 block uppercase tracking-wider">
          Batch Size <span className="normal-case text-emerald-500">(Max 500)</span>
        </label>
        <div className="flex items-center gap-2">
          <button
            onClick={handleDecrease}
            className="w-9 h-9 flex items-center justify-center rounded-xl bg-orange-50 border border-orange-200 text-orange-400 font-bold hover:bg-orange-100 transition-colors text-lg leading-none"
          >−</button>
          <input
            type="number"
            min={1}
            max={500}
            value={config.batchSize}
            onChange={handleBatchChange}
            disabled={disabled}
            className="flex-1 h-9 text-center bg-orange-50/60 border border-orange-200 rounded-xl text-sm font-bold text-slate-700 focus:outline-none focus:border-orange-400 focus:ring-2 focus:ring-orange-100 transition-all [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
          />
          <button
            onClick={handleIncrease}
            className="w-9 h-9 flex items-center justify-center rounded-xl bg-orange-50 border border-orange-200 text-orange-400 font-bold hover:bg-orange-100 transition-colors text-lg leading-none"
          >+</button>
        </div>
        <div className="flex gap-1.5 mt-2">
          {[50, 100, 250, 500].map((b) => (
            <button
              key={b}
              onClick={() => !disabled && setConfig((prev) => ({ ...prev, batchSize: b }))}
              className={`flex-1 py-1 rounded-lg text-[10px] font-bold transition-all duration-150 ${
                config.batchSize === b
                  ? 'bg-orange-400 text-white shadow-sm shadow-orange-200'
                  : 'bg-orange-50 text-orange-400 border border-orange-200 hover:bg-orange-100'
              }`}
            >
              {b}
            </button>
          ))}
        </div>
        <p className="text-[10px] text-emerald-500 mt-2 font-medium flex items-center gap-1">
          <span>✨</span> API allows up to 500 / batch!
        </p>
      </div>

      <div className="pt-2 border-t border-orange-50 text-xs text-slate-400 leading-relaxed">
        <p className="font-semibold text-slate-500 mb-1">Proxy Format</p>
        <code className="block bg-orange-50 border border-orange-100 rounded-xl p-2.5 text-slate-500 font-mono text-[11px] leading-5">
          ip:port
        </code>
      </div>
    </div>
  );
}